import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Navbar.css";
import { useTranslation } from "react-i18next";

function NavScrollExample() {
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  const handleClose = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const getLinkClass = (path) => (location.pathname === path ? "nav-link active" : "nav-link");
  const { t } = useTranslation();
  return (
    <>
      <Navbar expand="lg" className="bg-body-tertiary mt-3" id="navbar">
        <Container fluid className="justify-content-center">
          <Navbar.Toggle aria-controls="navbarScroll" onClick={handleShowModal} />
          <Navbar.Collapse id="navbarScroll" className="hidden-collapse">
            <Nav
              className="me-auto my-2 my-lg-0 justify-content-center"
              style={{ maxHeight: "100px", width: "100%", gap: "79px" }}
              navbarScroll
            >
              <Link to="/menu" className={getLinkClass("/menu")}>
                {t("navbar1")}
              </Link>
              <Link to="/appartament" className={getLinkClass("/appartament")}>
                {t("navbar2")}
              </Link>
              <Navbar.Brand href="/" id="tradizione1" className={getLinkClass("/")}>
                HOME
              </Navbar.Brand>
              <Link to="/Gallery" className={getLinkClass("/Gallery")}>
                {t("navbar3")}
              </Link>
              <Link to="/#end" className={getLinkClass("#contact")}>
                {t("navbar4")}
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Menù</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Nav className="flex-column modal-nav">
            <Link to="/" onClick={handleClose} className={getLinkClass("/")}>
              Home
            </Link>
            <hr className="modal-nav-separator" />
            <Link to="/menu" onClick={handleClose} className={getLinkClass("/menu")}>
              {t("navbar1")}
            </Link>
            <hr className="modal-nav-separator" />
            <Link to="/Gallery" onClick={handleClose} className={getLinkClass("/Gallery")}>
              {t("navbar3")}
            </Link>
            <hr className="modal-nav-separator" />
            <Link to="/appartament" onClick={handleClose} className={getLinkClass("/appartament")}>
              {t("navbar2")}
            </Link>
            <hr className="modal-nav-separator" />
            <Link to="/#end" onClick={handleClose} className={getLinkClass("/#end")}>
              {t("navbar4")}
            </Link>
          </Nav>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NavScrollExample;
